<template>
  <v-card>
    <v-toolbar card dense dark color="primary">
      <v-toolbar-title class="white--text">{{$t('login.cambiarContraseña')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="justify-center">
      <div>
      <v-text-field :type="'password'" :label="$t('login.nuevaContraseña')" v-model="newPassword"></v-text-field>
      <v-text-field :type="'password'" :label="$t('login.repiteContraseña')" v-model="newPasswordrepeat"></v-text-field>
      </div>
    </v-card-actions>
    <v-card-actions>
      <v-btn block flat class="secondary" @click="cerrar">{{$t('otros.cancelar')}}</v-btn>
      <v-btn
        block
        flat
        :class="puedoGuardar()?'primary':'secondary'"
        @click="btnChangePassword"
        :disabled="!puedoGuardar()"
      >{{$t('otros.establecer')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ChangePassword",
  data() {
    return {
      newPassword: "",
      newPasswordrepeat: "", 
    };
  },
  methods: {
    ...mapActions("Auth", ["changePassword"]),
    async btnChangePassword() {
      let ok = await this.changePassword(this.newPassword);
      if (ok) this.cerrar();
    },
    cerrar() {
      this.$emit("cerrar");
    },
    puedoGuardar() {
      return (this.newPassword.length > 3) && (this.newPassword===this.newPasswordrepeat);
    }
  }
};
</script>
